module.exports = __webpack_public_path__ + "static/media/alert-gray.686653e2.svg";